function buildSelectedIndices(options) {

  if (options.selectedIndex === -1) {
    return [];
  }

  return [options.selectedIndex];

}

function buildOnChange(configuration) {

  function onChange({ values, options }, indices) {

    if (values.length === 0) {
      return configuration.onChange(null, -1);
    }

    configuration.onChange(values[0], options[0], indices[0]);

  }

  return onChange;

}

export function convertMultiSelectOptionsToSingleSelectOptions(options) {

  return {
    ...options,
    selectedOptionIndices: buildSelectedIndices(options),
    onChange: buildOnChange(options)
  };

}

export function defaultOnClose() {

}

export function getAllOptionIndices(options) {

  const indices = [];
  const optionsLength = options.length;

  for (let index = 0; index < optionsLength; index++) {
    indices.push(index);
  }

  return indices;

}